<div class="error-incorrect-status-modal">
  <h1 class="error-incorrect-status-modal__title">{{ title }}</h1>
  <div class="error-incorrect-status-modal__content">
    Unfortunately your account for this particular portal and company is
    suspended. Full details about this suspension should have been outlined to
    you in a phone call.
    <br />
    If you think this is a mistake or have any questions, please call us on the
    telephone number for your area below;
    <br />
    <br />
    Thornbury Nursing Services -
    <a class="text-link" href="tel:0345 120 5251">0345 120 5251</a>
    <br />
    Scottish Nursing Guild, Scotland -
    <a class="text-link" href="tel:0131 221 7178">0131 221 7178</a>
    <br />
    Scottish Nursing Guild, Northern Ireland -
    <a class="text-link" href="tel:0131 221 7178">0131 221 7178</a>
    <br />
    Scottish Nursing Guild, Republic of Ireland -
    <a class="text-link" href="tel:01 902 3083">01 902 3083</a>
    <br />
    <br />
    <a class="text-link" [href]="dashboardUrl" target="_blank"
      >View all our portals here</a
    >
  </div>
  <div class="error-incorrect-status-modal__actions">
    <div class="error-incorrect-status-modal__actions__button">
      <ui-button
        (handleClick)="closeModal($event)"
        [isSecondary]="true"
        buttonClassName="button-full-width"
        buttonId="error-incorrect-status-modal-close"
        buttonText="Close"
        gtmTag="error-incorrect-status-modal-close"
      ></ui-button>
    </div>
  </div>
</div>
